/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ProductDtoBase } from "./ProductDtoBase";
import { RoofTrimStyle } from "./RoofTrimStyle";

export class RoofTrimProductDto extends ProductDtoBase {
    style: RoofTrimStyle;
}
